import { render, staticRenderFns } from "./SuppressionAdd.vue?vue&type=template&id=7c81465c"
import script from "./SuppressionAdd.vue?vue&type=script&lang=js"
export * from "./SuppressionAdd.vue?vue&type=script&lang=js"
import style0 from "./SuppressionAdd.vue?vue&type=style&index=0&id=7c81465c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports